package org.gymly.ui.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.staticCompositionLocalOf
import org.gymly.model.AdminPendingApprovalException

/**
 * Host global: cualquier pantalla puede mostrar «Necesitas aprobación»
 * sin duplicar estado por módulo.
 */
fun interface PendingApprovalNotifier {
    fun show(message: String)
}

val LocalPendingApprovalNotifier = staticCompositionLocalOf<PendingApprovalNotifier> {
    PendingApprovalNotifier { /* no-op fuera del shell admin */ }
}

@Composable
fun ProvidePendingApprovalNotifier(
    notifier: PendingApprovalNotifier,
    content: @Composable () -> Unit,
) {
    CompositionLocalProvider(LocalPendingApprovalNotifier provides notifier) {
        content()
    }
}

/** Muestra el popup si [error] es aprobación pendiente; devuelve true si lo manejó. */
fun PendingApprovalNotifier.offer(error: Throwable): Boolean {
    if (error !is AdminPendingApprovalException) return false
    show(
        error.message?.takeIf { it.isNotBlank() }
            ?: "Necesitas aprobación. Se avisó a quienes pueden autorizar.",
    )
    return true
}
